// extracted by mini-css-extract-plugin
export default {"add__container":"workFlowSwiper_add__container__OxOJ1","add__button":"workFlowSwiper_add__button__vx4uO","title":"workFlowSwiper_title__OSTHn"};